import moment from "moment";
import Vue from "vue";
import CommentList from "./post/CommentList";
import LinkPreview from "./post/LinkPreview";
import { EventBus } from "@/event-bus";
function formatDate(datatime) {
    let datatimes = new Date(datatime)
    let monthNamesThai = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน",
        "พฤษภาคม ", "มิถุนายน", "กรกฎาคม", "สิงหาคม",
        "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"]

    var Str =
        ("00" + datatimes.getDate()).slice(-2) + " " +
        monthNamesThai[(datatimes.getMonth())] + " " +
        datatimes.getFullYear()

    return Str
}
export default {
    props: ["item", "ownerOrAdmin"],
    components: {
        "comment-list": CommentList,
        "link-preview": LinkPreview,
        VuetifyAudio: () => import("vuetify-audio"),
    },
    data: () => ({
        showComment: false,
        text: "",
        liked: false,
        imageFiles: null,
        items_menu_more: [ "Edit","Delete"],
        previewImage: null,
        deletePostId: null,
        showConfirmDeleteDialog: false
    }),
    watch: {
        showComment(val) {
            if (val === true) {
                this.getComments();
            }
        },
    },
    computed: {
        isPublisher(){
            console.log(this.item.publisher.id, Vue.prototype.$userInfo._id)
            if(this.item.publisher.id == Vue.prototype.$userInfo._id){
                return true
            }
            return false
        }
    },
    mounted() {
        this.liked = this.item.liked;
    },
    filters: {
        moment: function (date) {
            let setDate = date / 1000
            let today = ((new Date()).getTime()) / 1000
            let minutesToday = today / 60
            let minutesSet = setDate / 60
            if ((minutesToday - minutesSet) < 60 && (minutesToday - minutesSet) < 1) {
                let minutes = ((minutesToday - minutesSet)).toFixed(0)
                console.log( minutes)
                return "ไม่กี่วินาทีที่ผ่านมา"
            }
            else if ((minutesToday - minutesSet) < 60) {
                let minutes = ((minutesToday - minutesSet)).toFixed(0)
                console.log( minutes)
                return minutes + " นาที"
            }
            else if ((minutesToday - minutesSet) / 60 < 24) {
                let hour = ((minutesToday - minutesSet) / 60).toFixed(0)
                return hour + " ชม."
            }
            else {
                let dateDay = formatDate(date)
                let timeDay = moment(date).format("HH:mm")
                return "เมื่อ " + dateDay + " เวลา " + timeDay + " น.";
            }

        },
    },
    methods: {
        async onFileChange(e) {
            // this.pageLoad = true;
            // await this.uploadFile(files);
            // this.pageLoad = false;
            this.pageLoad = true;
            console.log(e)
            // const file = e.target.files[0];
            // console.log(file)
            this.previewImage = URL.createObjectURL(e);
            this.pageLoad = false;
            // this.successUpload = false;
            // let totalFiles;
            // totalFiles = files.length;
            // let resultImg;
            // if (this.list.length + totalFiles > 20) {
            //   resultImg = 20 - this.list.length;
            //   this.warnnig(
            //     `คุณสามารถอัพโหลดรูปภาพได้อีก ${resultImg} รูปเท่านั้น กรุณาเลือกรูปใหม่อีกครั้ง`,
            //     "warning"
            //   );
            //   this.successUpload = true;
            //   this.imageFiles = [];
            //   return;
            // }
            // if (totalFiles === 0) {
            //   this.successUpload = true;
            //   return;
            // } else {
            //   for (var i = 0; i < totalFiles; i++) {
            //     // await this.uploadFile(files[i]);
            //   }
            //   this.successUpload = true;
            //   this.imageFiles = [];
            // }
        },
        async uploadFile(file) {
            // this.showUploadPercent = true;
            let formData = new FormData();
            formData.append("fileupload", file);
            formData.append("title", file.name);
            await Vue.axios
                .post(`${this.$store.state.api}/post/uploadfile/image`, formData, {
                    ...this.$store.getters.requestHeaders,
                    onUploadProgress: function (progressEvent) {
                        // this.progressPercent = parseInt(
                        //   Math.round((progressEvent.loaded / progressEvent.total) * 100)
                        // );
                    }.bind(this),
                })
                .then(
                    async function (response) {
                        await this.imageUploadId.push(response.data.result.url);
                        await this.imageForCreatePost.push(response.data.result);
                        // await this.oldFileId.push(response.data.result);
                        let imgUrl = response.data.result.url;
                        await this.list.push({ src: imgUrl });
                        this.n = { src: imgUrl };
                        // await this.oldFileUrl.push({ src: imgUrl });
                    }.bind(this)
                )
                .catch(function (e) { });
        },
        addComment() {
            if(this.text.trim() == "" && !this.imageFiles){
                return;
            }
            console.log(this.text.trim()  == "", this.imageFiles)
            console.log(this.item);
            this.pageLoad = true;
            let dataCreatePost = {
                idpost: this.item._id,
                text: this.text,
            };
            // if (this.imageForCreatePost && this.imageForCreatePost.length > 0) {
            //     dataCreatePost.image = this.imageForCreatePost[0];
            // }
            if(this.imageFiles){
                let formData = new FormData();
                formData.append("idpost", this.item._id);
                formData.append("text", this.text);
                formData.append("image", this.imageFiles);
                dataCreatePost = formData
            }
            Vue.axios
                .post(
                    `${this.$store.state.api}/postcomment/manage/insert`,
                    dataCreatePost,
                    this.$store.getters.requestHeaders
                )
                .then((res) => {
                    this.increaseTotalCommented();
                    this.pageLoad = false;
                    // this.showComments.unshift(res.data.result);
                    // this.$emit('clicked', 'someValue')
                    EventBus.$emit("addCommentToTop", {...res.data.result, postId: this.item._id});
                    this.clear();
                })
                .catch((err) => {
                    console.log(err);
                    this.errMsg = err.response.data.message;
                });
        },
        clear() {
            this.text = "";
            this.deleteImage();
          },
        deleteImage() {
        this.n = undefined;
        this.imageForCreatePost = [];
        this.imageFiles = undefined;
        this.previewImage = undefined
        },
        increaseTotalCommented() {
            this.item.totalCommented++;
        },
        likePost() {
            Vue.axios
                .post(
                    `${this.$store.state.api}/post/like`,
                    {
                        idpost: this.item._id,
                    },
                    this.$store.getters.requestHeaders
                )
                .then((res) => {
                    this.updateItem(res);
                    this.item.totalLiked++;
                })
                .catch((err) => {
                    this.errMsg = err.response.data.message;
                });
        },
        unLikePost() {
            Vue.axios
                .post(
                    `${this.$store.state.api}/post/unlike`,
                    {
                        idpost: this.item._id,
                    },
                    this.$store.getters.requestHeaders
                )
                .then((res) => {
                    this.updateItem(res);
                    if (this.item.totalLiked - 1 >= 0) {
                        this.item.totalLiked--;
                    }
                })
                .catch((err) => {
                    this.errMsg = err.response.data.message;
                });
        },
        updateItem(res) {
            if (res.data.status) {
                this.item.liked === res.data.result.liked;
                this.item.likes === res.data.result.likes;
                this.liked = res.data.result.liked;
            }
        },
        comments() {
            return this.item.comments || [];
        },
        getComments() { },
        eventShowComment() {
            this.showComment = !this.showComment;
        },
        downloadFile(item) {

            window.open(item.files.url, "_blank");
        },
        editPoster(id, text) {
            let payload = {
                id,
                text
            }
            EventBus.$emit("editPoster", payload);
        },
        async deletePost(){
            let dataDeletePost = {
                idpost: this.deletePostId
            };
            await Vue.axios
                .delete(
                    `${this.$store.state.api}/post/manage/delete`,
                    {
                        headers: this.$store.getters.requestHeaders,
                        data: dataDeletePost
                    }
                )
                .then(async (res) => {
                // await this.onDeletePostSuccess(this.editCommentId)
                if(res.data.result.delete){
                    await this.$store.commit("updateDiscusstionPostList", {...res.data.result, deleteId: this.deletePostId});
                }
                await this.clearParam()
                })
                .catch(async (err) => {
                await this.clearParam()
                });
        },
        openDeletePostDialog(postId){
            this.deletePostId = postId;
            this.showConfirmDeleteDialog = true;
        },
        clearParam(){
            this.deletePostId = null
            this.showConfirmDeleteDialog = false
          },
    },
};